import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';

import { useContent } from 'hooks';

const EngagementCount: FC = () => {
  const { engage_count } = useContent();
  const { t } = useTranslation();

  return <Typography>{t('content:xEngagement', { count: engage_count })}</Typography>;
};

export default EngagementCount;
